
import { useState } from "react";
import agendaWhite from "../images/icons/icon-user-agenda-white.svg";
import { RegisterPage1 } from "../components/register/RegisterPage1";
import { RegisterPage2 } from "../components/register/RegisterPage2";
import { RegisterPage3 } from "../components/register/RegisterPage3";
import { RegisterPage4 } from "../components/register/RegisterPage4";

export function Register({ setUser, changeSection }) {

  const[page, setPage] = useState(1);
  const[userData, setUserData] = useState({
    name:"",
    surname1:"",
    surname2:"",
    email:"",
    username:"",
    password:"",
    birthDateYear:"1940",
    birthDateMonth:"1",
    birthDateDay:"1",
    docExpirationYear:"2030",
    docExpirationMonth:"1",
  });
  const[errors, setErrors] = useState(
    {
      nameMissing:false,
      surname1Missing:false,
      surname2Missing:false,
      emailMissing:false,
      emailTaken:false,
      emailFormat:false,
      usernameMissing:false,
      usernameTaken:false,
      pass1Missing:false,
      pass2Missing:false,
    }
  );

  const page2_active = page >=2 ? "active" : "";
  const page3_active = page >=3 ? "active" : "";
  const page4_active = page >=4 ? "active" : "";


  return (
    <>
    <div className="total content-section a-bg a-bg--fixed bgRegister">
      <div className="container">
        <div className="o-frmRegister">
          <div className="m-iconTit">
            <img src={agendaWhite} alt="flotador-naranja" className="icon" />
              <span className="tit">Registrate</span>
          </div>
            
          <div className="o-stepMin">
            <div className="o-stepMin__loop">
              <div className="step active">
                <span>Paso 1</span>
              </div>
              <div className="arrow active"></div>
              <div className={ "step " + page2_active }>
                <span>Paso 2</span>
              </div>
              <div className={"arrow "+ page2_active}></div>
              <div className={ "step " + page3_active }>
                <span>Paso 3</span>
              </div>
              <div className={"arrow "+ page3_active}></div>
              <div className={ "step " + page4_active }>
                <span>Paso 4</span>
              </div>
            </div>
          </div>
            
            <div className="m-bxFormSpecial m-bxFormSpecial--padRLX2">
              <div className="bx">
              {page === 1 && (<RegisterPage1 setPage={setPage} errors={errors} userData={userData} setUserData={setUserData}/>)}
              {page === 2 && (<RegisterPage2 setPage={setPage} errors={errors}userData={userData} setUserData={setUserData}/>)}
              {page === 3 && (<RegisterPage3 setPage={setPage} userData={userData} setUserData={setUserData}/>)}
              {page === 4 && (<RegisterPage4 setPage={setPage} setErrors={setErrors} userData={userData} setUserData={setUserData} setUser={setUser} changeSection={changeSection}/>)}         
              </div>
            </div>
        </div>
      </div>
    
    </div>
    </>
  );
}